import * as PIXI from "pixi.js";
import Main from "../Main";
import UILayer from "../layers/UILayer";
import TextureManager from "../managers/TextureManager";
import SoundButton from "./buttons/SoundButton";
import HowToPlayButton from "./buttons/HowToPlayButton";
import { EventBus, EnumEventBus } from "../managers/EventBus";
import ManuelExplodeButton from "./buttons/ManuelExplodeButton";
import AutoExplodeButton from "./buttons/AutoExplodeButton";

const OPTIN_POPUP_PATH = "./images/scene/options_popup.png";


export default class OptionsPopup extends PIXI.Container {
  Main = Main.getInstance();
  UILayer = UILayer.getInstance();
  EventBus = EventBus;
  dim = this.Main.getDim();

  constructor() {
    super();
    this.addBg();
    this.addPopupBg();
    this.addToLayer();
    this.addSoundButton();
    this.addHowToPlayButton();
    this.addAutoExplodeButton();
    this.addManuelExplodeButton();

    this.visible = false;
    this.EventBus.on(EnumEventBus.setOptionsPopupVis, (v: number) => this.setVisible(Boolean(v)));
  }
  setVisible(value: boolean) {
    this.visible = value;
  }
  addClosePopupFunc(elm: PIXI.Sprite | PIXI.Graphics) {
    elm.on("mousedown", () => this.setVisible(false));
    elm.on("touchstart", () => this.setVisible(false));
  }
  addSoundButton() {
    const bounds = { x: this.dim.width / 2 - 75, y: this.dim.height / 2, width: 100, height: 100 };
    const button = new SoundButton(bounds, () => this.setVisible(false));
    this.addChild(button);
  }
  addHowToPlayButton() {
    const bounds = { x: this.dim.width / 2 - 135, y: this.dim.height / 2, width: 60, height: 60 };
    const htpButton = new HowToPlayButton(bounds);
    this.addChild(htpButton);
    this.addClosePopupFunc(htpButton);
  }
  addManuelExplodeButton() {
    const bounds = { x: this.dim.width / 2 + 60, y: this.dim.height / 2, width: 213, height: 60 };
    const manuelExplode = new ManuelExplodeButton(bounds);
    this.addChild(manuelExplode);
  }
  addAutoExplodeButton() {
    const bounds = { x: this.dim.width / 2 + 60, y: this.dim.height / 2, width: 213, height: 60 };
    const autoExplode = new AutoExplodeButton(bounds);
    this.addChild(autoExplode);
  }
  addBg() {
    const rect = new PIXI.Graphics()
      .rect(0, 0, this.dim.width, this.dim.height)
      .fill({ color: 0x000000, alpha: .3 });
    rect.interactive = true;

    this.addClosePopupFunc(rect);
    this.addChild(rect);
  }
  addPopupBg() {
    const texture = TextureManager.getTexture(OPTIN_POPUP_PATH);
    const bg = new PIXI.Sprite(texture);
    bg.anchor.set(.5);
    bg.width = 434 * .8;
    bg.height = 151 * .5;
    bg.x = this.dim.width / 2;
    bg.y = this.dim.height / 2;
    this.addChild(bg);
  }
  addToLayer() {
    this.UILayer.addChild(this);
  }
}